import {
  put,
  takeLatest,
} from 'redux-saga/effects';
import { MapTool } from '~/_shared/types/toolsAndFeatures/mapTools.types';
import { select } from '~/_shared/utils/saga/effects';
import { SidebarApp } from '~/sidebar/sidebarApp.enum';
import {
  clearLastOpenedMapPageTool,
  closeLeftSidebar, closeMapTool, openLeftSidebarApp,
  openMapTool,
  openMapToolExclusively,
} from '../../leftSidebar/leftSidebar.actionCreators';
import { frontendStateLeftSidebarSelector } from '../../leftSidebar/leftSidebar.selectors';
import { stopSelectLocationTool } from './selectLocation.actionCreators';
import { selectLocationConfigurationSelector } from './selectLocation.selectors';
import { SelectLocationConfiguration } from './selectLocation.state';

export function* selectLocationSagas() {
  yield takeLatest([
    openLeftSidebarApp,
    closeLeftSidebar,
    openMapTool,
    openMapToolExclusively,
    clearLastOpenedMapPageTool,
    closeMapTool,
  ], onToolChange);
}

function* onToolChange() {
  const leftSidebarState: ReturnType<typeof frontendStateLeftSidebarSelector> = yield select(frontendStateLeftSidebarSelector);
  const selectLocationConfiguration: ReturnType<typeof selectLocationConfigurationSelector> = yield select(selectLocationConfigurationSelector);

  if (selectLocationConfiguration) {
    if (
      selectLocationConfiguration === SelectLocationConfiguration.SetProximityToolStartLocation
      && (
        leftSidebarState.openedMapTool !== MapTool.Proximity
        || leftSidebarState.openedApp !== SidebarApp.Proximity
      )
    ) {
      yield put(stopSelectLocationTool());
    }

    if (
      selectLocationConfiguration === SelectLocationConfiguration.SetPlacesToolStartLocation
      && leftSidebarState.openedMapTool !== MapTool.Places
    ) {
      yield put(stopSelectLocationTool());
    }
  }
}
